import { AddressInput } from '@/shared/ui/address-input';
import { ExtendedAddress } from '../types';
import { Input, Info } from '@/shared/ui';
import { FormikErrors, FormikTouched } from 'formik';
import { withScrollRestoration } from '@/shared/hocs/withScrollRestoration';

interface AutoAddressProps {
    onAddressInputEvent: () => void;
    onAddressSelection: (address: ExtendedAddress) => void;
    handleManualInput: () => void;
    needsUnit: boolean;
    onAdditionalAddressChange: (value: string) => void;
    handleBlur: (field: string) => void;
    editedAddress?: boolean;
    values: ExtendedAddress;
    touched: FormikTouched<ExtendedAddress>;
    errors: FormikErrors<ExtendedAddress>;
}

const AutoAddress: React.FC<AutoAddressProps> = ({
    onAddressInputEvent,
    onAddressSelection,
    handleManualInput,
    needsUnit,
    onAdditionalAddressChange,
    handleBlur,
    editedAddress,
    values,
    touched,
    errors,
}) => {
    return (
        <>
            <AddressInput
                label="Shipping Address"
                name="addressLine1"
                subLabel="Start typing to search"
                placeholder="ex. 123 University St."
                selectedAddress={values}
                onAddressSeleted={onAddressSelection}
                onInputChange={onAddressInputEvent}
                required
                hasDelete={false}
                hasManualInput
                onManualInput={handleManualInput}
                error={touched.addressLine1 && Boolean(errors.addressLine1)}
                errorMessage={errors.addressLine1}
            />
            {needsUnit && (
                <Info className="my-4">
                    <p className="font-dmSans text-sm sm:text-15 leading-[1.43rem] text-primary-900">
                        The address you entered was found but more information is needed{' '}
                        <span className="font-dmSansMedium font-bold text-sm sm:text-base">(such as an apartment, suite, or box number)</span> to match to a specific address.
                        Please enter this information below.
                    </p>
                </Info>
            )}
            {(needsUnit || values.unit || editedAddress) && (
                <Input
                    className="manual_address__form_elements__unit"
                    label="Apartment/Suite/Box Number"
                    name="unit"
                    type="text"
                    placeholder="ex. #123, Suite 303"
                    value={values.unit}
                    onChange={e => onAdditionalAddressChange(e.target.value)}
                    onBlur={() => handleBlur('unit')}
                    error={touched.unit && Boolean(errors.unit)}
                    errorMessage={errors?.unit}
                    required
                    testId="address-unit"
                />
            )}
        </>
    );
};

export default withScrollRestoration(AutoAddress);
